/**
 * Created by piotr.pozniak@thebeaverhead.com on 25/02/2019.
 */

import React, { useCallback, useEffect, useRef, useState } from "react";
import OrganizationSubscription from "./PlanPage/OrganizationSubscription";
import SuccessAlert from "../component/SuccessAlert";
import { updateJquery } from "../tools";
import { useUserStore } from "../../../hooks/redux/user";
import LoadingIndicator from "./../../calendar/components/LoadingIndicator";
import useCloseModals from "../../../hooks/useCloseModals";
import { useSubscriptionPlansStore } from "../../../hooks/redux/subscriptionPlans";
import { useSubscriptionStore } from "../../../hooks/redux/subscription";
import { useAppStore } from "../../../hooks/redux/app";
import { useCurrentOrganizationStore } from "../../../hooks/redux/currentOrganization";
import { hasSubscription, hasTrialFinished } from "../helpers/organization";
import TabbedSettingsPage from "../templates/TabbedSettingsPage/TabbedSettingsPage";
import { WORKSPACE_SETTINGS_TABS } from "../templates/TabbedSettingsPage/settingsTabs";
import FreePlanSummary from "./PlanPage/FreePlanSummary";
import SubscriptionLimits from "../component/InfoWidgets/SubscriptionLimits";
import SubscriptionsPricingTable from "../component/Subscription/SubscriptionsPricingTable";
import DiscountHeader from "./PlanPage/DiscountHeader";

const PlansPage = (props) => {
  const [showPlansSelector, setShowPlansSelector] = useState(false);

  const { user, checkSession, resendActivationToken } = useUserStore();
  const { currentOrganization } = useCurrentOrganizationStore();
  const { fetchPlans, subscriptionPlans } = useSubscriptionPlansStore();
  const { subscription, fetchCustomerPortalLink, createStripeCheckoutSession } =
    useSubscriptionStore();
  const { clearErrors } = useAppStore();

  const isFetchingLink =
    subscription.startCheckoutSession ||
    subscription.stripeBillingPortalLinkFetch;

  const isLoading =
    subscription.fetch ||
    subscription.startCheckoutSession ||
    subscription.stripeBillingPortalLinkFetch ||
    subscription.stripeCustomerSessionFetch ||
    subscription.stripePaymentLinkFetch;

  const currentOrganizationModel = currentOrganization.model;

  // TODO
  const checkingPaymentTimeout = useRef(null);

  useCloseModals((e) => {}, []);

  useEffect(() => {
    if (
      subscription.startCheckoutSessionSuccess &&
      subscription.checkoutSession
    ) {
      window.open(subscription.checkoutSession.url, "_self");
    }
  }, [subscription.startCheckoutSessionSuccess, subscription.checkoutSession]);

  useEffect(() => {
    if (subscription.stripePaymentLink?.url) {
      window.open(subscription.stripePaymentLink.url, "_self");
    }
  }, [subscription.stripePaymentLink]);

  // rewardful
  useEffect(() => {
    const rewardful = window.Rewardful || null;
    if (rewardful) {
      rewardful.ready(() => {
        console.log("rewardful ready");
      });
    }
  }, []);

  useEffect(() => {
    /* console.log(
      "subscriptionPlans.fetchSuccess",
      subscriptionPlans.fetchSuccess,
      subscriptionPlans.collection.length
    );*/
    if (
      subscriptionPlans.fetchSuccess &&
      subscriptionPlans.collection.length &&
      showPlansSelector
    ) {
      setTimeout(
        () =>
          document.getElementById("subscription-pricing-table").scrollIntoView({
            block: "center",
            inline: "center",
            behavior: "smooth",
          }),
        100
      );
    }
  }, [subscriptionPlans.fetchSuccess]);

  // useEffect(() => {
  //   if (stripeCustomerSession) {
  //     attachScript("https://js.stripe.com/v3/pricing-table.js");
  //   }
  // }, [stripeCustomerSession]);

  // modal - TBD delete it
  useEffect(() => {
    clearErrors();
    //hideModal("#edit_plan");
    fetchPlans();

    // fetchCustomerSession();
    updateJquery();

    return () => {
      clearErrors();

      window.$("#edit_plan").modal("hide");
    };
  }, []);

  useEffect(() => {
    const checkPaymentProceeded = () => {
      //console.log("call checkPaymentProceeded");

      if (currentOrganizationModel.pending_payment * 1) {
        //console.log("checkPaymentProceeded set timeout");

        if (checkingPaymentTimeout.current) {
          clearTimeout(checkingPaymentTimeout.current);
        }
        checkingPaymentTimeout.current = setTimeout(() => {
          checkSession();
          checkPaymentProceeded();
        }, 5 * 1000);
      } else {
        //console.log("checkPaymentProceeded clear timeout");
        if (checkingPaymentTimeout.current) {
          clearTimeout(checkingPaymentTimeout.current);
        }
        checkingPaymentTimeout.current = null;
      }
    };

    if (
      currentOrganizationModel &&
      currentOrganizationModel.pending_payment * 1
    ) {
      //console.log("componentDidMount call check payment proceeded");
      // checkPaymentProceeded();
    }

    return () => {
      clearTimeout(checkingPaymentTimeout.current);
    };
  }, [currentOrganizationModel]);

  useEffect(() => {
    if (
      subscription.stripeBillingPortalLinkFetchSuccess &&
      subscription.stripeBillingPortalLink
    ) {
      window.open(subscription.stripeBillingPortalLink.url, "_self");
    }
  }, [subscription.stripeBillingPortalLinkFetchSuccess]);

  /**
   *
   * @param e
   * @returns {boolean}
   */
  const onResendActivationLink = (e) => {
    e.preventDefault();

    resendActivationToken();
    return false;
  };

  /**
   *
   * @type {(function(*): void)|*}
   */
  const onShowBillingHistory = useCallback(() => {
    if (isFetchingLink) {
      return;
    }
    fetchCustomerPortalLink();
  }, [isFetchingLink]);

  /**
   *
   * @type {(function(*): void)|*}
   */
  const onCancelSubscription = useCallback(() => {
    if (isFetchingLink) {
      return;
    }
    fetchCustomerPortalLink("subscription_cancel");
  }, [isFetchingLink]);

  /**
   *
   * @type {(function(*): void)|*}
   */
  const onChangeBillingDetails = useCallback(() => {
    if (isFetchingLink) {
      return;
    }
    fetchCustomerPortalLink();
  }, [isFetchingLink]);

  const onUpdatePlan = useCallback(() => {
    if (currentOrganization.subscription.is_terminated) {
      fetchCustomerPortalLink();
      // If the subscription is terminated, we redirect to the customer portal for subscription updates
    } else {
      setShowPlansSelector(true);
      fetchPlans();
    }
  }, [currentOrganization.subscription, showPlansSelector]);

  /**
   *
   * @type {(function(): void)|*}
   */
  const onAddPaymentMethod = useCallback(() => {
    // createPaymentLink(currentOrganization.subscription.stripe_price_id);
    createStripeCheckoutSession(
      currentOrganization.subscription.stripe_price_id
    );
  }, [currentOrganization.subscription]);

  const userModel = user.model;

  const isAccountVerified = userModel && userModel.is_account_verified;

  if (!isAccountVerified) {
    return (
      <TabbedSettingsPage
        title="Workspace settings"
        subtitle={
          currentOrganizationModel?.name &&
          `Applies to ${currentOrganizationModel.name}. Other workspaces are unaffected.`
        }
        tabs={WORKSPACE_SETTINGS_TABS}
      >
        <div className="row">
          <div className="col-lg-6">
            <div className="card-box">
              <div className="card-title">
                <h4>Activate your account</h4>
              </div>
              <p>
                We permit only verified accounts to subscribe and create
                calendars.
              </p>
              <p>
                Please check your mailbox for the email we sent you after you
                registered.
              </p>
              <p>
                If you did not receive an email from us, please check your
                SPAM folder. If no luck in there, please try to{" "}
                <a href="#" onClick={onResendActivationLink}>
                  resend the activation link
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </TabbedSettingsPage>
    );
  }

  const planSummary = (
    <>
      <SuccessAlert alertKind={"alert-info"}>
        {currentOrganizationModel &&
        currentOrganizationModel.pending_payment * 1
          ? "Your subscription payment is being processed. Your plan will become active shortly."
          : null}
      </SuccessAlert>

      <div className={"row"}>
        <div className={"col-md-6"}>
          <OrganizationSubscription
            onUpdatePlan={onUpdatePlan}
            onShowBillingHistory={onShowBillingHistory}
            onCancelSubscription={onCancelSubscription}
            onChangeBillingDetails={onChangeBillingDetails}
            disabled={isFetchingLink || isLoading}
            onAddPaymentMethod={onAddPaymentMethod}
          />
          <FreePlanSummary
            onUpdatePlan={onUpdatePlan}
            onShowBillingHistory={onShowBillingHistory}
            disabled={isFetchingLink || isLoading}
          />
        </div>
        <div className={"col-md-6"}>
          <SubscriptionLimits showManageButton={false} />
        </div>
      </div>
    </>
  );
  const stripePricing = subscriptionPlans.collection.length ? (
    <div className={"row"}>
      <div className={"col-12"} id={"subscription-pricing-table"}>
        <SubscriptionsPricingTable />
      </div>
    </div>
  ) : null;

  const content = (
    <>
      {planSummary}
      {showPlansSelector ? (
        <div className={"card-box"}>
          <DiscountHeader discount={subscriptionPlans.coupon} />
          {subscriptionPlans.fetch ? <LoadingIndicator /> : stripePricing}
        </div>
      ) : null}
    </>
  );

  return (
    <TabbedSettingsPage
      title="Workspace settings"
      subtitle={
        currentOrganizationModel?.name &&
        `Applies to ${currentOrganizationModel.name}. Other workspaces are unaffected.`
      }
      tabs={WORKSPACE_SETTINGS_TABS}
    >
      {content}
    </TabbedSettingsPage>
  );
};

export default PlansPage;
